import React from 'react';
import './SectionHeading.css';

const SectionHeading = ({ title, subtitle, centered = true }) => {
    return (
        <div 
            className={`yk-section-heading ${centered ? 'yk-section-heading-centered' : ''}`}
            style={{
                marginBottom: '2.5rem',
                paddingTop: '1rem',
                position: 'relative',
                textAlign: centered ? 'center' : 'left',
                display: 'flex',
                flexDirection: 'column',
                alignItems: centered ? 'center' : 'flex-start'
            }}
        >
            <div 
                className="yk-section-heading-icon"
                style={{ marginBottom: '0.5rem', display: 'block' }}
            >
                <img 
                    src="https://stssevastorage.blob.core.windows.net/ykwebsite/icons/Flute.png" 
                    alt="Flute decoration"
                    loading="lazy"
                    style={{ 
                        height: '45px', 
                        width: 'auto', 
                        display: 'inline-block',
                        filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))'
                    }}
                />
            </div>
            <h2 
                className="yk-section-heading-title"
                style={{
                    fontFamily: 'var(--yk-font-heading)',
                    fontSize: '2.25rem',
                    fontWeight: 700,
                    color: 'var(--yk-peacock-blue)',
                    margin: '0 0 0.5rem',
                    lineHeight: 1.2
                }}
            >
                {title}
            </h2>
            {subtitle && (
                <p 
                    className="yk-section-heading-subtitle"
                    style={{
                        fontFamily: 'var(--yk-font-body)',
                        fontSize: '1.0625rem',
                        fontWeight: 400,
                        color: '#1E293B',
                        margin: '0 auto 0.5rem',
                        lineHeight: 1.6,
                        maxWidth: '700px',
                        textAlign: 'center'
                    }}
                >
                    {subtitle}
                </p>
            )}
            <div 
                className="yk-section-heading-divider"
                style={{
                    width: '80px',
                    height: '4px',
                    background: 'linear-gradient(90deg, transparent, var(--yk-saffron), transparent)',
                    borderRadius: '2px',
                    margin: '0 auto'
                }}
            ></div>
        </div>
    );
};

export default SectionHeading;
